import { render, staticRenderFns } from "./searchBox.vue?vue&type=template&id=b9a5caaa&scoped=true"
import script from "./searchBox.vue?vue&type=script&lang=js"
export * from "./searchBox.vue?vue&type=script&lang=js"
import style0 from "./searchBox.vue?vue&type=style&index=0&id=b9a5caaa&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9a5caaa",
  null
  
)

export default component.exports